module.exports = __webpack_public_path__ + "static/swe-exp-2fb5b2fbf06cce2a4aa78f73019df4f8.svg";